//createworkoutplanner.js
import React, { useEffect, useState } from "react";
import { startLoader, stopLoader } from "../../../lib/utils";
import { getAllParameters } from "../../parameters/helper/api";
import { isAuthenticated } from "../../../auth";
import { useHistory, useLocation } from 'react-router-dom';
import '../style.scss';
import ContentList from "../components/contents";
import { getBranch } from "../../gyms/helper/api";
import ManageWarmUp from "../components/manage-warm-up";
import ManageDayWorkouts from "../components/manage-days";
import ManageCoolDown from "../components/manage-cool-down";
import CopyToDay from "./copyToDay";
import { createPlanner } from "../helper/api";
import Toast from "../../../lib/toast";

// --- Workout Preferences - Static Options ---
const genderOptions = ["Male", "Female", "Unisex"];

const fitnessGoalOptions = ["Weight Loss", "Fat Loss", "Muscle Gain", "Strength", "Endurance", "General Fitness", "Athletic Performance"];

const experienceLevelOptions = ["Beginner (0-3 Months)", "Intermediate (3 Months - 2 Years)", "Advanced (2+ Years)", "Professional"];

const workoutPreferenceOptions = ["Strength Training", "Hypertrophy", "Functional Training", "Cardio", "HIIT", "CrossFit", "Powerlifting", "Yoga", "Pilates", "Mobility / Flexibility"];

const ageGroupOptions = ["13 - 18", "19 - 30", "31 - 45", "46 - 60", "60+"];

const medicalConditionOptions = ["None", "Knee Pain", "Lower Back Pain", "Shoulder Injury", "Neck Pain", "High Blood Pressure", "Diabetes", "Heart Condition", "Pregnancy", "Obesity"];

const equipmentRequiredOptions = ["Bodyweight Only", "Dumbbells", "Barbells", "Resistance Bands", "Machines", "Kettlebells", "Cable Machine", "Mixed Equipment"];


const CreateWorkoutPlanner = (props) => {

  const history = useHistory();
  const {user, token} = isAuthenticated();
  const [currentElementId, setCurrentElementId] = useState("");
  const location = useLocation();
  const path = location.pathname;
  const [isButtonLock,setButtonLock] = useState(false);
  const [workoutPlanner, setWorkoutPlanner] = useState({
    workoutPlannerId: "",
    accessRight: "private",
    exerciseLevelIDs: [],
    name: "",
    warmup: [],
    coolDown: [],
    weekDays: [],
  });
  const [isAccessRightDropdown,setAccessRightDropdown]=useState(false);
  const accessRights=['private','public'];
  const [currentWindow, setCurrentWindow] = useState("home");
  const [currentDayIndex, setCurrentDayIndex] = useState(-1);
  const [isContentSelectionOpen, setContentSelectionOpen] = useState("");
  const [selectedGym, setSelectedGym] = useState();
  const [exerciseLevels, setExerciseLevels] = useState([]);
  const [warmUpContent, setWarmUpContent] = useState([]);
  const [coolDownContent, setCoolDownContent] = useState([]);
  const [dayContents, setDayContents] = useState([
    {
      displayName: "",
      dayName:"",
      content: []
    }    
  ]);


// --- Workout Preferences State ---

// Stores selected workout preferences for the planner
// Strings (single-select): gender, experienceLevel, ageGroup
// Arrays (multi-select): fitnessGoals, workoutPreferences, medicalConditions, equipmentRequired
  const [workoutPreferences, setWorkoutPreferences] = useState({
    gender: "",
    fitnessGoals: [],
    experienceLevel: "",
    workoutPreferences: [],
    ageGroup: "",
    medicalConditions: [],
    equipmentRequired: []
  });
   

  const [isWorkoutPreferencesOpen, setIsWorkoutPreferencesOpen] = useState(() => window.innerWidth > 767);

  const [copyFromIndex, setCopyFromIndex] = useState(-1);
  const [tempParentId, setTempParentId] = useState("");
  const [parameter, setParameter] = useState();

  const parameterTemplates = {
    weight: {
      set: [
        {
          reps: 15,
          weight: { value: 0, unit: "Kg" },
        }
      ],
      unit: "Kg",
      selectedSet: 0
    },
    number: { count: "" },
    time: { duration: "" },
    distance: { distance: "" }
  };

  const toggleInputFields = (id) => event => {
    event.preventDefault();
    setCurrentElementId(id);
    if(id == 'access-right') setAccessRightDropdown(!isAccessRightDropdown);
    event.stopPropagation();
  }

  const handleChange = name => event => {
    setWorkoutPlanner({
      ...workoutPlanner,
      [name]: event.target.value
    });
  }

  const handleSelectAccessRight=data=>{
    setWorkoutPlanner({
      ...workoutPlanner,
      accessRight:data
    });
  }

  const handleSelectedExerciseLevelIDs = id => event => {
    event.preventDefault();
    let list = [...workoutPlanner.exerciseLevelIDs];
    let index = list.indexOf(id);
    if (index == -1) {
      list.push(id)
    } else {
      list.splice(index, 1)
    }
    setWorkoutPlanner({
      ...workoutPlanner,
      exerciseLevelIDs: list
    })
  }
 // --- Workout Preferences Handlers ---
  const handleGenderChange = (value) => {
    setWorkoutPreferences(prev => ({ ...prev, gender: value }));
  };
  // Multi-select: Fitness Goals (toggle on/off, supports multiple selections)
  const handleFitnessGoalToggle = (value) => {
    setWorkoutPreferences(prev => {
      const list = [...prev.fitnessGoals];
      const index = list.indexOf(value);
      if (index === -1) list.push(value);
      else list.splice(index, 1);
      return { ...prev, fitnessGoals: list };
    });
  };

  // Single-select: Experience Level (radio button behavior)
  const handleExperienceLevelChange = (value) => {
    setWorkoutPreferences(prev => ({ ...prev, experienceLevel: value }));
  };

  // Multi-select: Workout Preferences (toggle on/off, supports multiple selections)
  const handleWorkoutPreferenceToggle = (value) => {
    setWorkoutPreferences(prev => {
      const list = [...prev.workoutPreferences];
      const index = list.indexOf(value);
      if (index === -1) list.push(value);
      else list.splice(index, 1);
      return { ...prev, workoutPreferences: list };
    });
  };

  // Single-select: Age Group (radio button behavior)
  const handleAgeGroupChange = (value) => {
    setWorkoutPreferences(prev => ({ ...prev, ageGroup: value }));
  };
 
  // Multi-select: Medical Conditions (toggle on/off, supports multiple selections)
  const handleMedicalConditionToggle = (value) => {
    setWorkoutPreferences(prev => {
      const list = [...prev.medicalConditions];
      const index = list.indexOf(value);
      if (index === -1) list.push(value);
      else list.splice(index, 1);
      return { ...prev, medicalConditions: list };
    });
  };

  // Multi-select: Equipment Required (toggle on/off, supports multiple selections)
  const handleEquipmentRequiredToggle = (value) => {
    setWorkoutPreferences(prev => {
      const list = [...prev.equipmentRequired];
      const index = list.indexOf(value);
      if (index === -1) list.push(value);
      else list.splice(index, 1);
      return { ...prev, equipmentRequired: list };
    });
  };

  const toggleCurrentWindow = (type, index) => {
    setCurrentWindow(type);
    
    if(index != currentDayIndex){
      setCurrentDayIndex(index)
    }else{
      setCurrentDayIndex(-1)
    }
  }

  const toggleContentList = (type) => {
    if(isContentSelectionOpen){
      setContentSelectionOpen("")
    }else{
      setContentSelectionOpen(type)
    }
  }


  const GetAllParams = async (type = "exerciseName") => {
    try {
      let params = {
        noLimit: 'noLimit',
        type
      };
      let responses = await getAllParameters(user._id, token, params);
      if (responses.error) {
        return []
      } else {
        return responses;
      }
    } catch (error) {
      return []
    }
  }

  const handleWarmUpContent = (content) => {
    setContentSelectionOpen("");
    setWarmUpContent([...warmUpContent, content]);
  }

  const handleCoolDownContent = (content) => {
    setContentSelectionOpen("");
    setCoolDownContent([...coolDownContent, content]);
  }

  const handleDayWorkoutContent = (newContent) => {
    // console.log(newContent);
    setContentSelectionOpen("");
    setDayContents(prev => {
      const updated = [...prev];
      if (!updated[currentDayIndex]) updated[currentDayIndex] = { content: [] };

      const dayContent = [...(updated[currentDayIndex].content || [])];

      const parameter = parameterTemplates[newContent.exerciseUnit] || {};
      parameter.unit = newContent.exerciseUnit ? newContent.exerciseUnit : "";
      parameter.isParameterAdded = true;

      const newContentWithParameter = {
        ...newContent,
        parameter,
        isParameterAdded: true
      };

      if (tempParentId !== "") {
        const index = dayContent.findIndex(c => c._id === tempParentId);

        if (index !== -1) {
          const parent = dayContent[index];

          const updatedParent = {
            ...parent,
            optionalContent: [
              ...(parent.optionalContent || []),
              newContentWithParameter
            ]
          };

          dayContent[index] = updatedParent;
        } else {
          dayContent.push(newContentWithParameter);
        }
      } else {
        dayContent.push(newContentWithParameter);
      }

      updated[currentDayIndex] = { ...updated[currentDayIndex], content: dayContent };
  
      setTempParentId("");

      return updated;
    });

  }


  const toggleOptionalContentList = (contentType, parentId) => {
    setContentSelectionOpen(contentType);
    setTempParentId(parentId);
  }

  const handleOptionalWarmUpContent = (content) => {
    if(tempParentId && content != null && currentWindow == "warm-up"){
      setContentSelectionOpen("");
      setWarmUpContent(prev =>
        prev.map(item =>
          item._id === tempParentId
            ? { ...item, optionalExercises: [...(item.optionalExercises || []), content] }
            : item
        )
      );
    }

    setTempParentId("");
  }

  const handleOptionalCoolDownContent = (content) => {
    if(tempParentId && content != null && currentWindow == "cool-down"){
      setContentSelectionOpen("");
      setCoolDownContent(prev =>
        prev.map(item =>
          item._id === tempParentId
            ? { ...item, optionalExercises: [...(item.optionalExercises || []), content] }
            : item
        )
      );
    }

    setTempParentId("");
  }
  
  const handleAddDayContent = () => {
    let obj = {
      displayName: "",
      dayName:"",
      content: []
    };
    setDayContents([...dayContents, obj])
  }

  const handleDeleteWorkoutPlanner = (index) => {
    setDayContents(prev => prev.filter((_, i) => i !== index));
  }

  const handleAddSet = (dayIndex, parentIndex, optionalIndex) => {
    setDayContents(prev => {
      const updated = [...prev];

      // ✅ Validate day
      const day = updated[dayIndex];
      if (!day) return prev;

      // ✅ Validate content array
      if (!Array.isArray(day.content)) day.content = [];

      // ✅ Validate parent exercise
      const parentItem = day.content[parentIndex];
      if (!parentItem) return prev;

      // ✅ If updating child inside optionalContent
      if (optionalIndex !== undefined && optionalIndex !== null) {
        if (!Array.isArray(parentItem.optionalContent)) parentItem.optionalContent = [];

        const childItem = parentItem.optionalContent[optionalIndex];
        
        if (!childItem) return prev;

        if (!childItem.parameter || !childItem.parameter.set) {
          childItem.parameter = { set: [] };
        }

        const lastSet = childItem.parameter.set.at(-1);
        const newSet = lastSet
          ? structuredClone(lastSet)
          : { reps: 15, weight: { value: null, unit: "" }, unit: "" };

        childItem.parameter.set.push(newSet);
        childItem.parameter.selectedSet = childItem.parameter.set.length - 1;
        return updated;
      }

      // ✅ Otherwise update main content item
      if (!parentItem.parameter || !parentItem.parameter.set) {
        parentItem.parameter = { set: [] };
      }

      const lastSet = parentItem.parameter.set.at(-1);
      const newSet = lastSet
        ? structuredClone(lastSet)
        : { reps: 15, weight: { value: null, unit: "" }, unit: "" };

      parentItem.parameter.set.push(newSet);
      parentItem.parameter.selectedSet = parentItem.parameter.set.length - 1;

      return updated;
    });
  };

  const handleDeleteSet = (dayIndex, parentIndex, setIndex, childIndex = null, childSetIndex = null) => {
    setDayContents(prev => {
      const updated = [...prev];

      // ✅ If deleting from child (optionalContent)
      if (childIndex !== null) {
        const childItem = updated[dayIndex].content[parentIndex].optionalContent[childIndex];

        // remove the set
        childItem.parameter.set = childItem.parameter.set.filter(
          (_, i) => i !== childSetIndex
        );

        // if no sets left, remove the whole optional item
        if (childItem.parameter.set.length === 0) {
          updated[dayIndex].content[parentIndex].optionalContent.splice(childIndex, 1);
        }

        return updated;
      }

      // ✅ If deleting from parent
      const parentItem = updated[dayIndex].content[parentIndex];
      parentItem.parameter.set = parentItem.parameter.set.filter(
        (_, i) => i !== setIndex
      );


      // if no sets left, remove the whole parent exercise
      if (parentItem.parameter.set.length === 0) {
        updated[dayIndex].content.splice(parentIndex, 1);
      }

      return updated;
    });
  };

  const handleUpdateSet = (dayIndex, parentIndex, setIndex, field, value, childIndex = null) => {
    setDayContents(prev => {
      const updated = prev.map((day, dI) => {
        if (dI !== dayIndex) return day;

        return {
          ...day,
          content: day.content.map((item, pI) => {
            if (pI !== parentIndex) return item;

            // ---------- CHILD UPDATE ----------
            if (childIndex !== null) {
              const childItem = item.optionalContent?.[childIndex];
              if (!childItem?.parameter?.set) return item;

              return {
                ...item,
                optionalContent: item.optionalContent.map((child, cI) => {
                  if (cI !== childIndex) return child;
                  if (!child?.parameter?.set) return child;

                  return {
                    ...child,
                    parameter: {
                      ...child.parameter,
                      set: child.parameter.set.map((s, sI) => {
                        if (sI !== setIndex) return s;
                        if (field.startsWith("weight.")) {
                          const key = field.split(".")[1];
                          return { ...s, weight: { ...s.weight, [key]: value } };
                        }
                        return { ...s, [field]: value };
                      })
                    }
                  };
                })
              };
            }

            // ---------- PARENT UPDATE ----------
            if (!item?.parameter?.set) return item;

            return {
              ...item,
              parameter: {
                ...item.parameter,
                set: item.parameter.set.map((s, sI) => {
                  if (sI !== setIndex) return s;
                  if (field.startsWith("weight.")) {
                    const key = field.split(".")[1];
                    return { ...s, weight: { ...s.weight, [key]: value } };
                  }
                  return { ...s, [field]: value };
                })
              }
            };
          })
        };
      });

      return updated;
    });
  };

  const handleSelectSet = (
    dayIndex,
    parentIndex,
    setIndex,
    childIndex = null,
    childSetIndex = null
  ) => {
    setDayContents(prev => {
      const updated = [...prev];

      // ---- Main Exercise (no childIndex) ---- //
      if (childIndex === null) {

        if (updated[dayIndex].content[parentIndex].parameter.selectedSet != null) {
          updated[dayIndex].content[parentIndex].parameter.selectedSet = setIndex;
        }
        return updated;
      }

      // ---- Child Exercise Exists ---- //
      if (
        updated[dayIndex].content[parentIndex].optionalContent[childIndex].parameter.selectedSet != null) {
        updated[dayIndex].content[parentIndex].optionalContent[childIndex].parameter.selectedSet = childSetIndex;
      }

      return updated;
    });
  };

  const handleCount = () => {
    
  }

  const handleDuration = () => {
    
  }

  const handleDistance = () => {
    
  }

  const handleCopyToDay = (index) => {
    if(index != copyFromIndex){
      setCopyFromIndex(index)
    }else{
      setCopyFromIndex(-1)
    }
  }

  const CopyContentToDay = (index) => {

    const copiedDayContent = dayContents[copyFromIndex].content;

    setDayContents(prev => {
      const updated = [...prev];
      updated[index].content = copiedDayContent;
      return updated;
    })
  }

  const handleDeleteContent = (dayIndex, parentIndex, optionalIndex) => {
    setDayContents(prev => {
      const updated = [...prev];
      
      const day = updated[dayIndex];
      if (!day || !Array.isArray(day.content)) return prev;

      const parentItem = day.content[parentIndex];
      if (!parentItem) return prev;

      // ✅ If deleting optional (child) content
      if (optionalIndex !== undefined && optionalIndex !== null) {
        if (!Array.isArray(parentItem.optionalContent)) return prev;

        parentItem.optionalContent.splice(optionalIndex, 1); // delete child

        // ✅ If optionalContent is now empty, keep array but do nothing else
        return updated;
      }

      // ✅ Otherwise delete main parent content item
      day.content.splice(parentIndex, 1);

      return updated;
    });
  };

  const handleDeleteWarmUpContent = (index, optionalIndex) => {
    setWarmUpContent(prev => {
      const updated = [...prev];

      if (optionalIndex !== undefined) {
        updated[index].optionalContent.splice(optionalIndex, 1);
      } else {
        updated.splice(index, 1);
      }

      return updated;
    });
  }

  const handleDeleteCoolDownContent = (index, optionalIndex) => {
    setCoolDownContent(prev => {
      const updated = [...prev];

      if (optionalIndex !== undefined) {
        updated[index].optionalContent.splice(optionalIndex, 1);
      } else {
        updated.splice(index, 1);
      }

      return updated;
    });
  }

  const handleDisplayName = (dayIndex, value) => {
    setDayContents(prev => {
      const updated = [...prev];
      updated[dayIndex].displayName = value;
      return updated;
    })
  }

  const handleCreatePlanner = async event => {

    if (event) event.preventDefault();

    if(workoutPlanner.name == ""){
      alert("Planner Name is Empty");
      return;
    }

    try {
      await startLoader();

      let payload = {
        name: workoutPlanner.name,
        accessRight: workoutPlanner.accessRight,
        exerciseLevelIDs: workoutPlanner.exerciseLevelIDs, 
        gender: workoutPreferences.gender,   // Workout Preferences - included in planner creation payload
        fitnessGoals: workoutPreferences.fitnessGoals,
        experienceLevel: workoutPreferences.experienceLevel,
        workoutPreferences: workoutPreferences.workoutPreferences,
        ageGroup: workoutPreferences.ageGroup,
        medicalConditions: workoutPreferences.medicalConditions,
        equipmentRequired: workoutPreferences.equipmentRequired,
        warmup: [],
        days: [],
        cooldown: [],
        isDayPlanner: true
      };

      if(user.role == 0) payload.isInstafitPlanner = true;
      else{
        payload.branchId = localStorage?.getItem("branchId")
        payload.gymId = localStorage?.getItem("gymId");
      }

      if (warmUpContent.length > 0) {
        await Promise.all(warmUpContent.map(async exercise => {
          let exerciseObject = {
            optionalExercises: []
          }
          if (exercise && exercise._id) exerciseObject.contentId = exercise._id;

          if(exercise.optionalExercises){
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({
                contentId: opex._id
              });
            }));
          }
          
          payload.warmup.push(exerciseObject)
        }))
      }

      if (dayContents.length > 0) {        
        await Promise.all(dayContents.map(async (day, index) => {
          let dayObject = {
            displayName: day.displayName,
            dayName: `day${index + 1}`,
            dayIndex: index,
            exercises: []
          };
          await Promise.all(day.content.map(async (exercise, index) => {
            let exerciseObject = {}
            if (exercise && exercise._id) {
              exerciseObject.contentId = exercise._id;
            }
            if (exercise.optionalContent && exercise.optionalContent.length > 0) {
              exerciseObject.optionalExercises = [];
              await Promise.all(exercise.optionalContent.map(d => {
                let opExObject = {
                  parameter: d.parameter ? d.parameter : {}
                };
                if (d && d._id) opExObject.contentId = d._id;
                exerciseObject.optionalExercises.push(opExObject);
              }));
            }
            if (exercise.parameter) {
              exerciseObject.parameter = exercise.parameter;
            }

            dayObject.exercises.push(exerciseObject);
          }))
          payload.days.push(dayObject)
        }))
      }

      if (coolDownContent.length > 0) {
        await Promise.all(coolDownContent.map(async exercise => {
          let exerciseObject = {
            optionalExercises: []
          }

          if (exercise && exercise._id) exerciseObject.contentId = exercise._id;

          if(exercise.optionalExercises){
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({ contentId: opex._id });
            }));
          }

          payload.cooldown.push(exerciseObject)
        }))
      }


      const response = await createPlanner(user._id, token, payload);

      if(response.error){
        new Toast({
          type:"error",
          message:response.error,
          duration:3000
        })
      }else{
        new Toast({
          type:"success",
          message:"Planner created successfully",
          duration:3000
        });
      }
      await stopLoader(); 

      if (path == "/planners") history.push("/planners");
      props.toggleAddWorkoutPlanner();
      setButtonLock(false);
    }catch (error) {
      new Toast({
        type:"error",
        message:error,
        duration:3000
      })
      await stopLoader();
      props.toggleAddWorkoutPlanner();
      setButtonLock(false);
    }
    
    
    if (event) event.stopPropagation();

  }

  const handleUpdateParam = (dayIndex, parentIndex, optionalIndex, key, value) => {
    setDayContents(prev => {
      const updated = [...prev];

      const day = updated[dayIndex];
      if (!day || !Array.isArray(day.content)) return prev;

      const parentItem = day.content[parentIndex];
      if (!parentItem) return prev;

      const target =
        optionalIndex !== undefined && optionalIndex !== null
          ? parentItem.optionalContent?.[optionalIndex]
          : parentItem;

      if (!target) return prev;

      if (!target.parameter) target.parameter = {};

      target.parameter[key] = value;

      return updated;
    });
  };



  useEffect(async () => {
    window.addEventListener("click", () => {
      setCurrentElementId("");
    })
    try {
      await startLoader();
      let exerciseLevelList = await GetAllParams('exerciseLevel');
      setExerciseLevels(exerciseLevelList)
      await stopLoader()
    } catch (error) {
      await stopLoader()
    }
  }, [])

  useEffect(() => {
    const fetchBranchFromStorage = async () => {
      const branchId = localStorage.getItem("branchId");
      if (branchId) {
        try {
          const response = await getBranch(user._id, token, branchId);
          if (!response.error) {
            setSelectedGym(response);
          } else {
            console.error("Branch fetch error:", response.error);
          }
        } catch (error) {
          console.error("Error fetching branch:", error);
        }
      }
    };

    fetchBranchFromStorage();
  }, [user._id, token]);

  
  // useEffect(() => {

  // },[warmUpContent, coolDownContent, dayContents])

  const dayPlannerBody = (
    <>
      {
        window.innerWidth > 767 && !props.hideHeader && (
          <div className="d-flex w-full space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "14px 14px 0 0"}}>
            <div className='d-flex'>
              <svg className='flex-item m-r-8 m-l-4' width="30" height="30" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.59375 5.90625C7.59375 5.68247 7.68264 5.46786 7.84088 5.30963C7.99911 5.15139 8.2137 5.0625 8.4375 5.0625H12.6562V6.75H8.4375C8.2137 6.75 7.99911 6.66111 7.84088 6.50287C7.68264 6.34464 7.59375 6.13003 7.59375 5.90625ZM0.84375 7.59375H4.21875C4.44253 7.59375 4.65714 7.68264 4.81537 7.84088C4.97361 7.99911 5.0625 8.2137 5.0625 8.4375C5.0625 8.6613 4.97361 8.8759 4.81537 9.0341C4.65714 9.1924 4.44253 9.2812 4.21875 9.2812H0.84375V7.59375Z" fill="#ffffff"/>
                <path d="M2.95312 0C3.06501 0 3.17232 0.04445 3.25144 0.12356C3.33055 0.20268 3.375 0.30999 3.375 0.42188V0.84375H10.125V0.42188C10.125 0.30999 10.1694 0.20268 10.2486 0.12356C10.3277 0.04445 10.435 0 10.5469 0C10.6588 0 10.7661 0.04445 10.8452 0.12356C10.9243 0.20268 10.9688 0.30999 10.9688 0.42188V0.84375H11.8125C12.2601 0.84375 12.6893 1.02154 13.0057 1.33801C13.3222 1.65447 13.5 2.0837 13.5 2.53125V11.8125C13.5 12.2601 13.3222 12.6893 13.0057 13.0057C12.6893 13.3222 12.2601 13.5 11.8125 13.5H1.6875C1.23995 13.5 0.81072 13.3222 0.49426 13.0057C0.17779 12.6893 0 12.2601 0 11.8125V2.53125C0 2.0837 0.17779 1.65447 0.49426 1.33801C0.81072 1.02154 1.23995 0.84375 1.6875 0.84375H2.53125V0.42188C2.53125 0.30999 2.5757 0.20268 2.65481 0.12356C2.73393 0.04445 2.84124 0 2.95312 0ZM0.84375 3.375V11.8125C0.84375 12.0363 0.93264 12.2509 1.09088 12.4091C1.24911 12.5674 1.46372 12.6562 1.6875 12.6562H11.8125C12.0363 12.6562 12.2509 12.5674 12.4091 12.4091C12.5674 12.2509 12.6562 12.0363 12.6562 11.8125V3.375H0.84375Z" fill="#ffffff"/>
              </svg>
              <p className="flex-item fs-22 m-l-4 font-weight-600 color-white">Day Planner</p>
            </div>
            <div onClick={()=>props.toggleAddWorkoutPlanner()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#E33A34"}}>
              <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="#ffffff" />
              </svg>
            </div>
          </div>
        )
      }

      {
        currentWindow == "home" && (
          <>
            <div
              className={`p-l-12 p-r-12 p-t-12 day-planner-home-scroll ${props.hideHeader ? "day-planner-home-mobile" : ""}`}>
               <div className="d-flex space-between">
                <div onClick={toggleInputFields('workout-planner-name')} className={`${(currentElementId == "workout-planner-name" || workoutPlanner.name) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "workout-planner-name" || workoutPlanner.name) ? "1px solid var(--darkBlue)" : "", width:"64%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "workout-planner-name" || workoutPlanner.name) ? "10px" : "14px", color: (currentElementId == "workout-planner-name" || workoutPlanner.name) ? "var(--darkBlue)" : "", transition: "180ms" }}>Planner Name</p>
                  </div>
                  <input id="workout-planner-name" onChange={handleChange("name")} value={workoutPlanner.name} className={`${(currentElementId == "workout-planner-name" || workoutPlanner.name) ? "active-input-field" : "inactive-input-field"}`} placeholder="Enter Planner Name" type="text" />
                </div>
                <div onClick={toggleInputFields('access-right')} className={`${currentElementId == "access-right" || workoutPlanner.accessRight ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: currentElementId == "access-right" || workoutPlanner.accessRight ? "1px solid var(--darkBlue)" : "", width:"33%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "access-right" || workoutPlanner.accessRight ? "10px" : "14px", color: currentElementId == "access-right" || workoutPlanner.accessRight ? "var(--darkBlue)" : "", transition: "180ms"}}>Access Right*</p>
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" style={{ transform: isAccessRightDropdown ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                    </svg>
                  </div>
                  <input id="access-right" className={`${currentElementId == "access-right" || workoutPlanner.accessRight ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gym Type" value={workoutPlanner.accessRight} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                  {
                    isAccessRightDropdown && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                        {
                          accessRights.map(data=>{
                            return (
                              <div onClick={()=>handleSelectAccessRight(data)} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item" style={{textTransform:'capitalize'}}>{data}</p>
                              </div>
                            );
                          })
                        }
                      </div>
                    )
                  }
                </div>
              </div>

              {/* Workout Preferences - Collapsible */}
              <div className="workout-preferences-container m-b-20 m-t-20">
                <div className={`workout-preferences-header ${isWorkoutPreferencesOpen ? "wp-open" : "wp-closed"}`} onClick={() => setIsWorkoutPreferencesOpen(!isWorkoutPreferencesOpen)}>
                  <div className="wp-header-title">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 5H17M3 10H17M3 15H17" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                      <circle cx="7" cy="5" r="2" fill="#055075"/>
                      <circle cx="13" cy="10" r="2" fill="#055075"/>
                      <circle cx="7" cy="15" r="2" fill="#055075"/>
                    </svg>
                    <p className="fs-16 font-weight-700">Workout Preferences</p>
                  </div>
                  <svg className={`wp-header-arrow ${isWorkoutPreferencesOpen ? "wp-rotated" : ""}`} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L7 7L13 1" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </div>

                {isWorkoutPreferencesOpen && (
                  <div className="workout-preferences-body">

                    {/* Row 1: Gender, Fitness Goal, Experience Level */}
                    <div className="workout-preferences-row">

                      {/* Gender */}
                      <div className="workout-preferences-item">
                        <div className="wp-item-title">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="5" r="3" stroke="#055075" strokeWidth="1.5" fill="none"/>
                            <path d="M8 8V15" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                          <p className="fs-14 font-weight-700">Gender</p>
                        </div>
                        <div className="wp-radio-list">
                          {genderOptions.map(option => (
                            <label key={option} className="wp-radio">
                              <input type="radio" name="gender" value={option} checked={workoutPreferences.gender === option} onChange={() => handleGenderChange(option)} />
                              <span>{option}</span>
                            </label>
                          ))}
                        </div>
                      </div>

                      {/* Fitness Goal */}
                      <div className="workout-preferences-item">
                        <div className="wp-item-title wp-title-align-top">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="6" stroke="#055075" strokeWidth="1.5" fill="none"/>
                            <circle cx="8" cy="8" r="3" stroke="#055075" strokeWidth="1.5" fill="none"/>
                            <circle cx="8" cy="8" r="1" fill="#055075"/>
                          </svg>
                          <div>
                            <p className="fs-14 font-weight-700">Fitness Goal</p>
                            <span className="wp-subtitle">(Select all that apply)</span>
                          </div>
                        </div>
                        <div className="wp-chip-list">
                          {fitnessGoalOptions.map(option => (
                            <div key={option} onClick={() => handleFitnessGoalToggle(option)} className={`wp-chip ${workoutPreferences.fitnessGoals.includes(option) ? "wp-chip-active" : ""}`}>
                              <span>{option}</span>
                              {workoutPreferences.fitnessGoals.includes(option) && (
                                <svg width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" strokeWidth="1" strokeLinecap="round"/>
                                </svg>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Experience Level */}
                      <div className="workout-preferences-item">
                        <div className="wp-item-title">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 14V10" stroke="#055075" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M6 14V6" stroke="#055075" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M10 14V3" stroke="#055075" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M14 14V1" stroke="#055075" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          <p className="fs-14 font-weight-700">Experience Level</p>
                        </div>
                        <div className="wp-radio-list">
                          {experienceLevelOptions.map(option => (
                            <label key={option} className="wp-radio">
                              <input type="radio" name="experienceLevel" value={option} checked={workoutPreferences.experienceLevel === option} onChange={() => handleExperienceLevelChange(option)} />
                              <span>{option}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Row 2: Workout Preference, Age Group */}
                    <div className="workout-preferences-row wp-row-2col">

                      {/* Workout Preference */}
                      <div className="workout-preferences-item">
                        <div className="wp-item-title wp-title-align-top">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 8H14M5 4V12M11 4V12" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                          <div>
                            <p className="fs-14 font-weight-700">Workout Preference</p>
                            <span className="wp-subtitle">(Select all that apply)</span>
                          </div>
                        </div>
                        <div className="wp-chip-list">
                          {workoutPreferenceOptions.map(option => (
                            <div key={option} onClick={() => handleWorkoutPreferenceToggle(option)} className={`wp-chip ${workoutPreferences.workoutPreferences.includes(option) ? "wp-chip-active" : ""}`}>
                              <span>{option}</span>
                              {workoutPreferences.workoutPreferences.includes(option) && (
                                <svg width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" strokeWidth="1" strokeLinecap="round"/>
                                </svg>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Age Group */}
                      <div className="workout-preferences-item">
                        <div className="wp-item-title">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="5" r="3" stroke="#055075" strokeWidth="1.5" fill="none"/>
                            <path d="M2 15C2 11.6863 4.68629 9 8 9C11.3137 9 14 11.6863 14 15" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                          <p className="fs-14 font-weight-700">Age Group</p>
                        </div>
                        <div className="wp-radio-list wp-radio-list-age">
                          {ageGroupOptions.map(option => (
                            <label key={option} className="wp-radio">
                              <input type="radio" name="ageGroup" value={option} checked={workoutPreferences.ageGroup === option} onChange={() => handleAgeGroupChange(option)} />
                              <span>{option}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Row 3: Medical Conditions, Equipment Required */}
                    <div className="workout-preferences-row wp-row-2col-equal">

                      {/* Medical Conditions */}
                      <div className="workout-preferences-item">
                        <div className="wp-item-title wp-title-align-top">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 1L1 8L8 15L15 8L8 1Z" stroke="#055075" strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
                            <path d="M8 5V11M5 8H11" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                          <div>
                            <p className="fs-14 font-weight-700">Medical Conditions</p>
                            <span className="wp-subtitle">(Select all that apply)</span>
                          </div>
                        </div>
                        <div className="wp-chip-list">
                          {medicalConditionOptions.map(option => (
                            <div key={option} onClick={() => handleMedicalConditionToggle(option)} className={`wp-chip ${workoutPreferences.medicalConditions.includes(option) ? "wp-chip-active" : ""}`}>
                              <span>{option}</span>
                              {workoutPreferences.medicalConditions.includes(option) && (
                                <svg width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" strokeWidth="1" strokeLinecap="round"/>
                                </svg>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Equipment Required */}
                      <div className="workout-preferences-item">
                        <div className="wp-item-title wp-title-align-top">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 4H12V12H4V4Z" stroke="#055075" strokeWidth="1.5" fill="none"/>
                            <path d="M6 2V4M10 2V4M6 12V14M10 12V14M2 6H4M12 6H14M2 10H4M12 10H14" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                          <div>
                            <p className="fs-14 font-weight-700">Equipment Required</p>
                            <span className="wp-subtitle">(Select all that apply)</span>
                          </div>
                        </div>
                        <div className="wp-chip-list">
                          {equipmentRequiredOptions.map(option => (
                            <div key={option} onClick={() => handleEquipmentRequiredToggle(option)} className={`wp-chip ${workoutPreferences.equipmentRequired.includes(option) ? "wp-chip-active" : ""}`}>
                              <span>{option}</span>
                              {workoutPreferences.equipmentRequired.includes(option) && (
                                <svg width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" strokeWidth="1" strokeLinecap="round"/>
                                </svg>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                  </div>
                )}
              </div>
              <p className="fs-16 font-weight-700 color-red">Select Exercise Level *</p>
              <div className="modal-item-scroll-container-1 m-t-8 m-b-20">
                <div className="d-flex-wrap w-full h-full modal-item-scroll-inner">
                  {
                    exerciseLevels.map(data => {
                      return (
                        <div onClick={handleSelectedExerciseLevelIDs(data._id)} className={`global-button-container ${([...workoutPlanner.exerciseLevelIDs]).indexOf(data._id) != -1 ? "global-button-container-active" : ""} d-flex flex-item p-l-12 p-r-12 m-r-20 m-b-12`}>
                          <p className='flex-item'>{data.name}</p>
                        </div>
                      )
                    })
                  }
                </div>
              </div> 
              <p className="fs-16 font-weight-700 color-red">Manage Exercises *</p>
              <div className="d-flex m-t-12">
                <div onClick={() => toggleCurrentWindow("warm-up")} className='warm-cool-container m-r-20 d-flex'>
                  <p className='flex-item m-r-20 warm-cool-label'>Warm Up</p>
                  <svg className='flex-item' width="24" height="24" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={warmUpContent && warmUpContent.length > 0 ? "#5D883C" : "#E0E0E0"} />
                    <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                  </svg>
                </div>
                <div onClick={() => toggleCurrentWindow("cool-down")} className='warm-cool-container d-flex'>
                  <p className='flex-item m-r-20 warm-cool-label'>Cool Down</p>
                  <svg className='flex-item' width="24" height="24" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={coolDownContent &&  coolDownContent.length > 0 ? "#5D883C" : "#E0E0E0"} />
                    <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                  </svg>
                </div>
              </div>
              <div className="days-of-workout-container m-t-16">
                <p className="fs-14 font-weight-700 m-b-12">Day Of Workout(s) - {dayContents.length} of 7 </p>
                <div className="d-flex-wrap w-full">
                  {
                    dayContents.map((data,index) => {
                      return(
                        <div onClick={() => toggleCurrentWindow("day-workout", index)} className={`global-button-container d-flex flex-item p-l-12 p-r-12 m-r-20 m-b-12 ${data.content.length > 0 ? "day-chip-active" : ""}`}>
                          <p className={`flex-item ${data.content.length > 0 ? "day-chip-label-active" : ""}`}>Day {index + 1}</p>
                          <svg className='flex-item m-l-20' width="20" height="20" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={data.content.length > 0 ? "#5D883C" : "#ffffff"} />
                            <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke={data.content.length > 0 ? "#ffffff" : "#6d6d6d"} stroke-width="1" stroke-linecap="round" />
                          </svg>

                          <div onClick={(e)=>e.stopPropagation()} className="d-flex flex-item">
                            {
                              (dayContents.length > 1 && data.content.length != 0) && (
                                <div onClick={()=> handleCopyToDay(index)} className="flex-item copy-to-day-wrapper">
                                  <svg className="flex-item d-flex m-l-12" width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.625 2.9375C8.625 2.18025 8.625 1.80163 8.5015 1.50344C8.41983 1.30615 8.30008 1.12689 8.1491 0.9759C7.99811 0.824915 7.81885 0.705167 7.62156 0.6235C7.32338 0.5 6.94475 0.5 6.1875 0.5H3.75C2.21762 0.5 1.45225 0.5 0.976125 0.976125C0.5 1.45225 0.5 2.21762 0.5 3.75V6.1875C0.5 6.94475 0.5 7.32338 0.6235 7.62156C0.705167 7.81885 0.824915 7.99811 0.9759 8.1491C1.12689 8.30008 1.30615 8.41983 1.50344 8.5015C1.80163 8.625 2.18025 8.625 2.9375 8.625" stroke="#FFA10B"/>
                                    <path d="M11.875 5.375H7C6.10254 5.375 5.375 6.10254 5.375 7V11.875C5.375 12.7725 6.10254 13.5 7 13.5H11.875C12.7725 13.5 13.5 12.7725 13.5 11.875V7C13.5 6.10254 12.7725 5.375 11.875 5.375Z" stroke="#FFA10B"/>
                                  </svg>
                                  {
                                    copyFromIndex == index && (
                                      <CopyToDay copyFrom={copyFromIndex} totalDays={dayContents.length} CopyContentToDay={(index)=>CopyContentToDay(index)} />
                                    )
                                  }
                                </div>
                              )
                            }

                            {
                              index != 0 && (
                                <svg onClick={()=>handleDeleteWorkoutPlanner(index)} className="flex-item m-l-12" width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="7.5" cy="7.5" r="7.5" fill="#E33A34"/>
                                  <path d="M4.51953 10.7083L10.4779 4.75M10.4779 10.7083L4.51953 4.75" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              ) 
                            }
                          </div>

                        </div>
                      )
                    })
                  }
                  {
                    dayContents.length > 0 && dayContents.length < 7 && (
                      <div onClick={()=>handleAddDayContent()} className="d-flex add-day-dashed-btn cursor-pointer m-r-20 m-b-12">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="icon-mr-6">
                          <path d="M7 1V13M1 7H13" stroke="#055075" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <span className="fs-13 font-weight-600 add-day-label">Add Day</span>
                      </div>
                    )
                  }
                </div>

                <div className="d-flex workout-note">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="icon-mr-6">
                    <circle cx="7" cy="7" r="6" stroke="#6d6d6d" strokeWidth="1"/>
                    <path d="M7 4V7.5M7 9.5V10" stroke="#6d6d6d" strokeWidth="1" strokeLinecap="round"/>
                  </svg>
                  <p className="fs-12 workout-note-text">You can add, remove or reorder days as per your plan.</p>
                </div>
              </div>
            </div>
            <div onClick={(e)=>handleCreatePlanner(e)} className="w-full d-flex day-planner-create-btn">
              <div className="member-button-global member-button-global-active w-full btn-center d-flex create-planner-btn-inner">
                <p className="flex-item fs-16 create-planner-btn-text">Create Planner</p>
              </div>
            </div>
          </>
        )
      }

      {
        currentWindow == "warm-up" && (
          <div className="flex-item p-l-12 p-r-12 p-t-12 w-full h-full">
            <div className="d-flex space-between">
              <div className="flex-item">
                <p className="fs-18 font-weight-700">Warm Up</p>
                <p className="fs-14 font-weight-600 color-red">Content(s)</p>
              </div>
              <div className="selected-content-container d-flex selected-content-top">
                <div className="d-flex content-count-container">
                  <p className="flex-item margin-auto color-white font-weight-600">{warmUpContent.length}</p>
                </div>
                <p className="flex-item m-l-6 m-r-12 font-weight-600 color-white">Selected Content</p>
                {
                  warmUpContent.length > 0 && (
                    <div onClick={()=>toggleContentList("warm-up")} className="d-flex preview-container m-r-2 cursor-pointer">
                      {
                        isContentSelectionOpen == "warm-up" ? (
                          <svg className="flex-item margin-auto" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.854511 0.14662C0.808029 0.100136 0.752848 0.0632624 0.692117 0.0381053C0.631386 0.0129482 0.566295 4.89791e-10 0.500561 0C0.434826 -4.89792e-10 0.369735 0.0129482 0.309004 0.0381053C0.248274 0.0632624 0.193092 0.100136 0.146611 0.14662C0.100129 0.193104 0.0632585 0.248289 0.038103 0.309024C0.0129474 0.369758 -4.89761e-10 0.434853 0 0.500592C4.89761e-10 0.566331 0.0129474 0.631426 0.038103 0.69216C0.0632585 0.752895 0.100129 0.80808 0.146611 0.854564L3.64612 4.35229C1.91316 5.53475 0.706634 7.34358 0.280592 9.39789C0.267199 9.46217 0.266597 9.52845 0.278819 9.59296C0.291042 9.65747 0.315851 9.71894 0.351828 9.77386C0.387806 9.82879 0.434248 9.87608 0.488503 9.91305C0.542759 9.95003 0.603764 9.97595 0.668037 9.98934C0.73231 10.0027 0.798592 10.0033 0.863097 9.99112C0.927603 9.97889 0.98907 9.95408 1.04399 9.9181C1.09891 9.88212 1.1462 9.83568 1.18317 9.78142C1.22014 9.72716 1.24606 9.66615 1.25945 9.60187C1.45084 8.67863 1.82421 7.80276 2.35776 7.02539C2.89131 6.24803 3.57435 5.58473 4.36701 5.07423L5.94979 6.65611C5.53728 6.95201 5.19408 7.33413 4.944 7.77595C4.69393 8.21777 4.54297 8.70871 4.5016 9.21471C4.46023 9.72071 4.52943 10.2297 4.70442 10.7062C4.8794 11.1828 5.15597 11.6156 5.51494 11.9746C5.87391 12.3336 6.30668 12.6102 6.78323 12.7852C7.25977 12.9602 7.76869 13.0294 8.27466 12.988C8.78063 12.9466 9.27154 12.7957 9.71333 12.5456C10.1551 12.2955 10.5372 11.9523 10.8331 11.5397L15.1455 15.8534C15.2394 15.9473 15.3667 16 15.4994 16C15.6322 16 15.7595 15.9473 15.8534 15.8534C15.9473 15.7595 16 15.6322 16 15.4994C16 15.3666 15.9473 15.2393 15.8534 15.1454L0.854511 0.14662ZM8.12348 6.00316L11.486 9.36589C11.4521 8.48486 11.087 7.64907 10.4636 7.02562C9.8402 6.40218 9.00446 6.03702 8.12348 6.00316ZM5.52985 3.41036L6.33274 4.2133C6.87698 4.07157 7.43711 3.99999 7.9995 4.00032C11.205 4.00032 14.0556 6.32713 14.7385 9.60187C14.7656 9.73182 14.8432 9.8457 14.9542 9.91846C15.0652 9.99121 15.2005 10.0169 15.3305 9.98984C15.4604 9.96279 15.5743 9.88523 15.647 9.77422C15.7198 9.66321 15.7455 9.52783 15.7184 9.39789C14.9415 5.67318 11.692 3.00039 7.9995 3.00039C7.14462 3.00039 6.31174 3.14338 5.52985 3.41036Z" fill="black"/>
                          </svg>
                        ) : (
                          <svg className="flex-item margin-auto" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.02504 6.602C1.73081 3.327 4.6812 1 8 1C11.3188 1 14.2682 3.327 14.975 6.602C15.003 6.73196 15.0832 6.84584 15.1981 6.91861C15.313 6.99137 15.4531 7.01705 15.5876 6.99C15.7221 6.96295 15.8399 6.88538 15.9152 6.77436C15.9905 6.66334 16.0171 6.52796 15.9891 6.398C15.185 2.673 11.8217 0 8 0C4.17826 0 0.814959 2.673 0.0108719 6.398C-0.0171232 6.52796 0.0094528 6.66334 0.0847536 6.77436C0.160054 6.88538 0.277912 6.96295 0.412398 6.99C0.546885 7.01705 0.686984 6.99137 0.801876 6.91861C0.916768 6.84584 0.997041 6.73196 1.02504 6.602ZM7.98965 3C8.95027 3 9.87154 3.36875 10.5508 4.02513C11.2301 4.6815 11.6117 5.57174 11.6117 6.5C11.6117 7.42826 11.2301 8.3185 10.5508 8.97487C9.87154 9.63125 8.95027 10 7.98965 10C7.02903 10 6.10776 9.63125 5.4285 8.97487C4.74924 8.3185 4.36764 7.42826 4.36764 6.5C4.36764 5.57174 4.74924 4.6815 5.4285 4.02513C6.10776 3.36875 7.02903 3 7.98965 3Z" fill="black"/>
                          </svg>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
            <div className="section-divider" />
            {
              (isContentSelectionOpen == "warm-up" || warmUpContent.length == 0) ? (
                <ContentList warmUpContents={warmUpContent} contentType="warm-up" selectedGym={selectedGym} toggleContentList={()=> warmUpContent.length == 0 ? toggleCurrentWindow("home") : toggleContentList("warm-up")} handleWarmUpContent={handleWarmUpContent} handleOptionalWarmUpContent={handleOptionalWarmUpContent} parentContentId={tempParentId} />
              ) : (
                <div className="w-full manage-content-wrapper">
                  <ManageWarmUp warmUpContent={warmUpContent} toggleContentList={()=>toggleContentList("warm-up")} toggleCurrentWindow={()=>toggleCurrentWindow("home")}  toggleOptionalContentList={(contentType, parentId) => toggleOptionalContentList(contentType, parentId)} handleDeleteWarmUpContent={(index, optionalIndex) => handleDeleteWarmUpContent(index, optionalIndex)} />
                </div>
              )
            }
          </div>
        )
      }

      {
        currentWindow == "day-workout" && (
          <div className="flex-item p-l-12 p-r-12 p-t-12 w-full h-full">
            <div className="d-flex space-between">
              <div className="flex-item">
                <p className="fs-18 font-weight-700">Day {currentDayIndex + 1}</p>
                <p className="fs-14 font-weight-600 color-red">Content(s)</p>
              </div>
              <div className="selected-content-container d-flex selected-content-top">
                <div className="d-flex content-count-container">
                  <p className="flex-item margin-auto color-white font-weight-600">{dayContents[currentDayIndex].content.length}</p>
                </div>
                <p className="flex-item m-l-6 m-r-12 font-weight-600 color-white">Selected Content</p>
                {
                  dayContents[currentDayIndex].content.length > 0 && (
                    <div onClick={()=>toggleContentList("day-workout")} className="d-flex preview-container m-r-2 cursor-pointer">
                      {
                        (isContentSelectionOpen == "day-workout" || dayContents[currentDayIndex].content.length > 0) ? (
                          <svg className="flex-item margin-auto" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.854511 0.14662C0.808029 0.100136 0.752848 0.0632624 0.692117 0.0381053C0.631386 0.0129482 0.566295 4.89791e-10 0.500561 0C0.434826 -4.89792e-10 0.369735 0.0129482 0.309004 0.0381053C0.248274 0.0632624 0.193092 0.100136 0.146611 0.14662C0.100129 0.193104 0.0632585 0.248289 0.038103 0.309024C0.0129474 0.369758 -4.89761e-10 0.434853 0 0.500592C4.89761e-10 0.566331 0.0129474 0.631426 0.038103 0.69216C0.0632585 0.752895 0.100129 0.80808 0.146611 0.854564L3.64612 4.35229C1.91316 5.53475 0.706634 7.34358 0.280592 9.39789C0.267199 9.46217 0.266597 9.52845 0.278819 9.59296C0.291042 9.65747 0.315851 9.71894 0.351828 9.77386C0.387806 9.82879 0.434248 9.87608 0.488503 9.91305C0.542759 9.95003 0.603764 9.97595 0.668037 9.98934C0.73231 10.0027 0.798592 10.0033 0.863097 9.99112C0.927603 9.97889 0.98907 9.95408 1.04399 9.9181C1.09891 9.88212 1.1462 9.83568 1.18317 9.78142C1.22014 9.72716 1.24606 9.66615 1.25945 9.60187C1.45084 8.67863 1.82421 7.80276 2.35776 7.02539C2.89131 6.24803 3.57435 5.58473 4.36701 5.07423L5.94979 6.65611C5.53728 6.95201 5.19408 7.33413 4.944 7.77595C4.69393 8.21777 4.54297 8.70871 4.5016 9.21471C4.46023 9.72071 4.52943 10.2297 4.70442 10.7062C4.8794 11.1828 5.15597 11.6156 5.51494 11.9746C5.87391 12.3336 6.30668 12.6102 6.78323 12.7852C7.25977 12.9602 7.76869 13.0294 8.27466 12.988C8.78063 12.9466 9.27154 12.7957 9.71333 12.5456C10.1551 12.2955 10.5372 11.9523 10.8331 11.5397L15.1455 15.8534C15.2394 15.9473 15.3667 16 15.4994 16C15.6322 16 15.7595 15.9473 15.8534 15.8534C15.9473 15.7595 16 15.6322 16 15.4994C16 15.3666 15.9473 15.2393 15.8534 15.1454L0.854511 0.14662ZM8.12348 6.00316L11.486 9.36589C11.4521 8.48486 11.087 7.64907 10.4636 7.02562C9.8402 6.40218 9.00446 6.03702 8.12348 6.00316ZM5.52985 3.41036L6.33274 4.2133C6.87698 4.07157 7.43711 3.99999 7.9995 4.00032C11.205 4.00032 14.0556 6.32713 14.7385 9.60187C14.7656 9.73182 14.8432 9.8457 14.9542 9.91846C15.0652 9.99121 15.2005 10.0169 15.3305 9.98984C15.4604 9.96279 15.5743 9.88523 15.647 9.77422C15.7198 9.66321 15.7455 9.52783 15.7184 9.39789C14.9415 5.67318 11.692 3.00039 7.9995 3.00039C7.14462 3.00039 6.31174 3.14338 5.52985 3.41036Z" fill="black"/>
                          </svg>
                        ) : (
                          <svg className="flex-item margin-auto" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.02504 6.602C1.73081 3.327 4.6812 1 8 1C11.3188 1 14.2682 3.327 14.975 6.602C15.003 6.73196 15.0832 6.84584 15.1981 6.91861C15.313 6.99137 15.4531 7.01705 15.5876 6.99C15.7221 6.96295 15.8399 6.88538 15.9152 6.77436C15.9905 6.66334 16.0171 6.52796 15.9891 6.398C15.185 2.673 11.8217 0 8 0C4.17826 0 0.814959 2.673 0.0108719 6.398C-0.0171232 6.52796 0.0094528 6.66334 0.0847536 6.77436C0.160054 6.88538 0.277912 6.96295 0.412398 6.99C0.546885 7.01705 0.686984 6.99137 0.801876 6.91861C0.916768 6.84584 0.997041 6.73196 1.02504 6.602ZM7.98965 3C8.95027 3 9.87154 3.36875 10.5508 4.02513C11.2301 4.6815 11.6117 5.57174 11.6117 6.5C11.6117 7.42826 11.2301 8.3185 10.5508 8.97487C9.87154 9.63125 8.95027 10 7.98965 10C7.02903 10 6.10776 9.63125 5.4285 8.97487C4.74924 8.3185 4.36764 7.42826 4.36764 6.5C4.36764 5.57174 4.74924 4.6815 5.4285 4.02513C6.10776 3.36875 7.02903 3 7.98965 3Z" fill="black"/>
                          </svg>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
            <div className="section-divider" />
            {
              (isContentSelectionOpen == "day-workout" || dayContents[currentDayIndex].content.length == 0) ? (
                <ContentList dayContents={dayContents} contentType="day-workout" selectedGym={selectedGym} toggleContentList={()=> dayContents[currentDayIndex].content.length == 0 ? toggleCurrentWindow("home") : toggleContentList("day-workout")} handleDayWorkoutContent={handleDayWorkoutContent} dayIndex={currentDayIndex} parentContentId={tempParentId} />
              ) : (
                <div className="w-full manage-content-wrapper">
                  <ManageDayWorkouts toggleCurrentWindow={()=>toggleCurrentWindow("home")} toggleContentList={()=>toggleContentList("day-workout")} dayContents={dayContents} dayIndex={currentDayIndex} handleDisplayName={(dayIndex, value)=>handleDisplayName(dayIndex, value)} toggleOptionalContentList={(contentType, parentId) => toggleOptionalContentList(contentType, parentId)} handleAddSet={(dayIndex, parentIndex, optionalIndex) => handleAddSet(dayIndex, parentIndex, optionalIndex)} handleDeleteSet={(dayIndex, parentIndex, setIndex, childIndex, childSetIndex) => handleDeleteSet(dayIndex, parentIndex, setIndex, childIndex, childSetIndex)} handleUpdateSet={(dayIndex, parentIndex, setIndex, field, value, childIndex) => handleUpdateSet(dayIndex, parentIndex, setIndex, field, value, childIndex)} handleSelectSet={(dayIndex, parentIndex, setIndex, childIndex, childSetIndex)=>handleSelectSet(dayIndex, parentIndex, setIndex, childIndex, childSetIndex)} handleUpdateParam={(dayIndex, parentIndex, optionalIndex, key, value)=>handleUpdateParam(dayIndex, parentIndex, optionalIndex, key, value)} handleDeleteContent={(dayIndex, parentIndex, optionalIndex)=>handleDeleteContent(dayIndex, parentIndex, optionalIndex)}/>
                </div>
              )
            }
          </div>
        ) 
      }

      {
        currentWindow == "cool-down" && (
          <div className="flex-item p-l-12 p-r-12 p-t-12 w-full h-full">
            <div className="d-flex space-between">
              <div className="flex-item">
                <p className="fs-18 font-weight-700">Cool Down</p>
                <p className="fs-14 font-weight-600 color-red">Content(s)</p>
              </div>
              <div className="selected-content-container d-flex selected-content-top">
                <div className="d-flex content-count-container">
                  <p className="flex-item margin-auto color-white font-weight-600">{coolDownContent.length}</p>
                </div>
                <p className="flex-item m-l-6 m-r-12 font-weight-600 color-white">Selected Content</p>
                {
                  coolDownContent.length > 0 && (
                    <div onClick={()=>toggleContentList("cool-down")} className="d-flex preview-container m-r-2 cursor-pointer">
                      {
                        isContentSelectionOpen == "cool-down" ? (
                          <svg className="flex-item margin-auto" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.854511 0.14662C0.808029 0.100136 0.752848 0.0632624 0.692117 0.0381053C0.631386 0.0129482 0.566295 4.89791e-10 0.500561 0C0.434826 -4.89792e-10 0.369735 0.0129482 0.309004 0.0381053C0.248274 0.0632624 0.193092 0.100136 0.146611 0.14662C0.100129 0.193104 0.0632585 0.248289 0.038103 0.309024C0.0129474 0.369758 -4.89761e-10 0.434853 0 0.500592C4.89761e-10 0.566331 0.0129474 0.631426 0.038103 0.69216C0.0632585 0.752895 0.100129 0.80808 0.146611 0.854564L3.64612 4.35229C1.91316 5.53475 0.706634 7.34358 0.280592 9.39789C0.267199 9.46217 0.266597 9.52845 0.278819 9.59296C0.291042 9.65747 0.315851 9.71894 0.351828 9.77386C0.387806 9.82879 0.434248 9.87608 0.488503 9.91305C0.542759 9.95003 0.603764 9.97595 0.668037 9.98934C0.73231 10.0027 0.798592 10.0033 0.863097 9.99112C0.927603 9.97889 0.98907 9.95408 1.04399 9.9181C1.09891 9.88212 1.1462 9.83568 1.18317 9.78142C1.22014 9.72716 1.24606 9.66615 1.25945 9.60187C1.45084 8.67863 1.82421 7.80276 2.35776 7.02539C2.89131 6.24803 3.57435 5.58473 4.36701 5.07423L5.94979 6.65611C5.53728 6.95201 5.19408 7.33413 4.944 7.77595C4.69393 8.21777 4.54297 8.70871 4.5016 9.21471C4.46023 9.72071 4.52943 10.2297 4.70442 10.7062C4.8794 11.1828 5.15597 11.6156 5.51494 11.9746C5.87391 12.3336 6.30668 12.6102 6.78323 12.7852C7.25977 12.9602 7.76869 13.0294 8.27466 12.988C8.78063 12.9466 9.27154 12.7957 9.71333 12.5456C10.1551 12.2955 10.5372 11.9523 10.8331 11.5397L15.1455 15.8534C15.2394 15.9473 15.3667 16 15.4994 16C15.6322 16 15.7595 15.9473 15.8534 15.8534C15.9473 15.7595 16 15.6322 16 15.4994C16 15.3666 15.9473 15.2393 15.8534 15.1454L0.854511 0.14662ZM8.12348 6.00316L11.486 9.36589C11.4521 8.48486 11.087 7.64907 10.4636 7.02562C9.8402 6.40218 9.00446 6.03702 8.12348 6.00316ZM5.52985 3.41036L6.33274 4.2133C6.87698 4.07157 7.43711 3.99999 7.9995 4.00032C11.205 4.00032 14.0556 6.32713 14.7385 9.60187C14.7656 9.73182 14.8432 9.8457 14.9542 9.91846C15.0652 9.99121 15.2005 10.0169 15.3305 9.98984C15.4604 9.96279 15.5743 9.88523 15.647 9.77422C15.7198 9.66321 15.7455 9.52783 15.7184 9.39789C14.9415 5.67318 11.692 3.00039 7.9995 3.00039C7.14462 3.00039 6.31174 3.14338 5.52985 3.41036Z" fill="black"/>
                          </svg>
                        ) : (
                          <svg className="flex-item margin-auto" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.02504 6.602C1.73081 3.327 4.6812 1 8 1C11.3188 1 14.2682 3.327 14.975 6.602C15.003 6.73196 15.0832 6.84584 15.1981 6.91861C15.313 6.99137 15.4531 7.01705 15.5876 6.99C15.7221 6.96295 15.8399 6.88538 15.9152 6.77436C15.9905 6.66334 16.0171 6.52796 15.9891 6.398C15.185 2.673 11.8217 0 8 0C4.17826 0 0.814959 2.673 0.0108719 6.398C-0.0171232 6.52796 0.0094528 6.66334 0.0847536 6.77436C0.160054 6.88538 0.277912 6.96295 0.412398 6.99C0.546885 7.01705 0.686984 6.99137 0.801876 6.91861C0.916768 6.84584 0.997041 6.73196 1.02504 6.602ZM7.98965 3C8.95027 3 9.87154 3.36875 10.5508 4.02513C11.2301 4.6815 11.6117 5.57174 11.6117 6.5C11.6117 7.42826 11.2301 8.3185 10.5508 8.97487C9.87154 9.63125 8.95027 10 7.98965 10C7.02903 10 6.10776 9.63125 5.4285 8.97487C4.74924 8.3185 4.36764 7.42826 4.36764 6.5C4.36764 5.57174 4.74924 4.6815 5.4285 4.02513C6.10776 3.36875 7.02903 3 7.98965 3Z" fill="black"/>
                          </svg>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
            <div className="section-divider" />
            {
              (isContentSelectionOpen == "cool-down" || coolDownContent.length == 0) ? (
                <ContentList coolDownContents={coolDownContent} contentType="cool-down" selectedGym={selectedGym}  toggleContentList={()=> coolDownContent.length == 0 ? toggleCurrentWindow("home") : toggleContentList("cool-down")} handleCoolDownContent={handleCoolDownContent} handleOptionalCoolDownContent={handleOptionalCoolDownContent} parentContentId={tempParentId} />
              ) : (
                <div className="w-full manage-content-wrapper">
                  <ManageCoolDown coolDownContent={coolDownContent} toggleContentList={()=>toggleContentList("cool-down")} toggleCurrentWindow={()=>toggleCurrentWindow("home")}  toggleOptionalContentList={(contentType, parentId) => toggleOptionalContentList(contentType, parentId)} handleDeleteCoolDownContent={(index, optionalIndex) => handleDeleteCoolDownContent(index, optionalIndex)}/>
                </div>
              )
            }
          </div>
        )
      }
    </>
  );

   return(
    props.hideHeader ? (
      <div className="day-planner-drawer-content flex-item d-flex flex-col">
        {dayPlannerBody}
      </div>
    ) : (
      <div className="global-modal-container d-flex">
        <div className="global-modal-type-2 planner-assign-modal flex-item d-flex flex-col" style={{padding:window.innerWidth < 768 && "12px", width: window.innerWidth > 768 ? "50%" : "100%", height:"90vh",alignItems:"stretch"}}>
          {dayPlannerBody}
        </div>
      </div>
    )
  )
}

export default CreateWorkoutPlanner;